import { defineMessages } from "react-intl";

export const messages = defineMessages({
	title: {
		id: "timeline.title",
		defaultMessage: "Idővonal"
	},
	concepts: {
		id: "timeline.concepts",
		defaultMessage: "Fogalmak"
	},
	tags: {
		id: "timeline.tags",
		defaultMessage: "Cimkék"
	},
	noEvents: {
		id: "timeline.no_events",
		defaultMessage: "Nincsenek esemenyék"
	}
});
